module.exports = __webpack_public_path__ + "roboto-black-webfont.2afdb3fccec5f4d49a0e.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-black-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-black-webfont.ttf
// module chunks = styles